import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { BindDeviceActionTypes, BindDeviceActions } from '../actions/bind-device.actions';
import {DevicesService} from '../../../services/devices.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { AddUpdateDeviceParams, MiniCardWithoutPackParams } from '../../../models/devices';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';



@Injectable()
export class BindDeviceEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);

  constructor() {}

  GetBindDevices$ = createEffect(() => this.actions$.pipe(
    ofType(BindDeviceActionTypes.GetBindDevices),
    map((action: featureActions.GetBindDevices) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param: AddUpdateDeviceParams = {
        ...payload,
        OtpKey: payload.OtpKey || user.otp,
      };
      return this.deviceService.addUpdateDevice(param).pipe(
        map((res) => {
          // rType: Wifi card(1), Mini card(2), Emb card(3)
          const result = { ...res, type: updateInfoType.BindDevice };
          if (result.Flag) {
            const successResult = { ...result, msg: param.rType };
            return new featureActions.UpdateInfoSuccessAction(successResult);
          } else {
            const errorResult = { ...result, errmsg: param.rType };
            return new featureActions.UpdateInfoFailAction(errorResult);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: param.rType,
            type: updateInfoType.BindDevice
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
  GetBindDevicesWithoutPack$ = createEffect(() => this.actions$.pipe(
    ofType(BindDeviceActionTypes.GetBindDevicesWithoutPack),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param: MiniCardWithoutPackParams = !action.payload.otp 
        ? { ...action.payload, otp: user.otp }
        : action.payload;
      return this.deviceService.addMiniCardWithoutPack(param).pipe(
        map((res) => {
          // rType: Wifi card(1), Mini card(2), Emb card(3)
          const result = { ...res, type: updateInfoType.BindDeviceWithoutPack, msg: param.rType };
          if (result.result) {
            return new featureActions.UpdateInfoSuccessAction(result);
          } else {
            return new featureActions.UpdateInfoFailAction(result);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: param.rType,
            type: updateInfoType.BindDeviceWithoutPack
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));

}
